import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';
import { DropdownMenuContainer } from 'components/DropdownMenu/DropdownMenuContainer';
import { useQuickUploadFile } from 'client/contexts/QuickUploadFile';
import { ACCEPTED_FILE_TYPES } from 'screens/EpisodeOptionsScreen/components/EpisodeContent/constants';
import { NEW_EPISODE_MENU_ITEMS } from '../../constants';
import styles from '../../../../shared/Button/styles.sass';

const NewEpisodeNavUnwrapped = (props: RouteComponentProps) => {
  const cx = classNames(styles.button, styles.onDark);
  const { history } = props;
  const { setQuickUploadFile } = useQuickUploadFile();

  const handleOnDrop = (acceptedFiles: File[]) => {
    setQuickUploadFile(acceptedFiles[0]);
    history.push('/dashboard/episode/new/publish');
  };

  return (
    <Dropzone
      onDrop={handleOnDrop}
      accept={ACCEPTED_FILE_TYPES}
      noClick
      noKeyboard
    >
      {({ getRootProps, getInputProps, open }) => {
        // pass down function that opens the file picker
        NEW_EPISODE_MENU_ITEMS[0].onClick = open;

        return (
          <div {...getRootProps()} style={{ textAlign: 'left' }}>
            <input {...getInputProps()} />
            <DropdownMenuContainer
              buttonStyles={cx}
              renderPressableContent="New Episode"
              shouldShowDistributionItem={false}
              menuItems={NEW_EPISODE_MENU_ITEMS}
              flyoutBorderRadius={16}
              flyoutMarginTop={4}
              flyoutPaddingTopBottom={0}
              flyoutWidth={278}
              alignFlyout="bottom"
            />
          </div>
        );
      }}
    </Dropzone>
  );
};

const NewEpisodeNav = withRouter(NewEpisodeNavUnwrapped);
export { NewEpisodeNav };
